import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "default-search",
  "use": "default-search-usage",
  "viewBox": "0 0 30 31",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 30 31\" id=\"default-search\"><path d=\"M17.59 21.257A11.446 11.446 0 0111.5 23C5.149 23 0 17.851 0 11.5S5.149 0 11.5 0 23 5.149 23 11.5c0 2.945-1.107 5.63-2.927 7.665l9.075 9.268-2.265 2.313-9.292-9.49zM11.5 20a8.5 8.5 0 100-17 8.5 8.5 0 000 17z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol